(function () {
    'use strict';

    angular
        .module('app')
        .controller('DeleteEntityTemplateDialogCtrl', DeleteEntityTemplateDialogCtrl);

    DeleteEntityTemplateDialogCtrl.$inject = ['DialogInstance', 'EntityTemplatesService', 'entityTemplateIds', 'showCheckbox'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting the user for confirmation they wish to delete an entity template.
     * 
     * @param {int} tagIds - Ids of entity templates that are to be deleted.
     */
    function DeleteEntityTemplateDialogCtrl(DialogInstance, EntityTemplatesService, entityTemplateIds, showCheckbox) {
        /* jshint validthis:true */
        var vm = this;
        vm.allEntityTemplateCountsSelected = true;
        vm.showCheckbox = showCheckbox;
        vm.loading = true;
        vm.ok = ok;
        vm.cancel = cancel;
        Object.defineProperty(vm, 'confirmMessage', {
            get: function () {
                return entityTemplateIds.length > 1 ? ('Delete the Entity Templates?') : 'Delete the Entity Template?';
            }
        });

        activate();

        function activate() {
            getUsage().finally(function () {
                _.forEach(vm.entityTemplateCounts, function (entityTemplateCount) {
                    entityTemplateCount.Selected = true;
                });

                vm.loading = false;
            });
        }

        function getUsage() {
            return EntityTemplatesService.getItemCount(entityTemplateIds)
                            .then(getItemCountOk)
                            .catch(getItemCountError);

            function getItemCountOk(response) {
                vm.entityTemplateCounts = response;
            }

            function getItemCountError(response) {
                if (response.status === 404) {
                    vm.entityTemplateNotFound = true;
                }

                vm.error = true;
            }
        }

        function ok() {
            if (vm.entityTemplateNotFound) {
                DialogInstance.cancel();
            }

            var selectedEntityTemplateIds = _.map(_.filter(vm.entityTemplateCounts, function (entityTemplateCount) { return entityTemplateCount.Selected; }), 'EntityTemplate.Id');

            DialogInstance.ok(selectedEntityTemplateIds);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
